import React from 'react';

export enum AttachmentContentType {
  text,
  magazine,
  customImage,
  image,
  video,
  sound,
  articles
}

export interface AttachmentContentTypeContextValue {
  contentType: AttachmentContentType | null;
  // Nullable: closing the modal clears the type, and every caller that does so passes
  // null. The signature said otherwise and nothing noticed while context was typed any.
  changeContentType: (type: AttachmentContentType | null) => void;
}

export const AttachmentContentTypeContext = React.createContext<AttachmentContentTypeContextValue>({
  contentType: null,
  changeContentType: _type => null,
});
